import { useContext } from 'react';
import ToastContext from './ToastContext';

export default () => useContext(ToastContext);
